module.exports = __webpack_public_path__ + "img/生产制造.fbe9cbca.png";